import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState("fr");

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);

export const tx = (lang, obj) => obj?.[lang] ?? obj?.en ?? "";
